import { useOutletContext } from "react-router-dom"
import { Grid } from "@mui/material"
import AlertSettingsMovedNotice from "widgets/alerts/settings/AlertSettingsMovedNotice"

import type { Tower } from "types/towers.types"

import TowerDetails from "widgets/towers/settings/TowerDetails"
import { BodyContainer } from "widgets/styled/containers"

const TowerSettings = () => {
  const { tower } = useOutletContext<{ tower: Tower }>()

  return (
    <BodyContainer disableGutters maxWidth="xl" sx={{ pt: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AlertSettingsMovedNotice />
        </Grid>
        <Grid item xs={12}>
          <TowerDetails tower={tower} />
        </Grid>
      </Grid>
    </BodyContainer>
  )
}

export default TowerSettings
